import React from 'react';

import { InfoCard } from '../InfoCard/InfoCard';

interface IProps {
  rating: string;
  timeframe: string;
}

function getClassName(rating: string): string {
  if (rating === 'Great' || rating === 'Good') {
    return 'bg-success-tint';
  }
  if (rating === 'Poor') {
    return 'bg-error-tint';
  }
  return '';
}

export const BiteTimeCard = ({ rating, timeframe }: IProps) => {
  return (
    <InfoCard
      title="Fishing forecast"
      iconText={rating}
      bottomText={timeframe}
      className={getClassName(rating)}
    />
  );
};
